import React from 'react';
import ReactCardFlip from 'react-card-flip';
import './App.scss';
import events from './events';
import faq from './faq';

function App() {
  return (
    <div className="App">
      <header className="header">
        <img className="cover" alt="cover" /> {/* SPECIFIED IN CSS */}
        <div className="content">
          <h3>ICS Student Council invites you to WebJam, a week-long competition where teams of students will create fully functional web applications — no experience necessary! We'll be providing workshops throughout the week to help you get started, and awarding amazing prizes for the best projects out there!</h3>
          <a href="https://forms.gle/YWDp8CzFCEGq8zEX8"><h4 className="accent">Register</h4></a>
          <a href="https://forms.gle/GYHLnpYQvTawFS3y8"><h4>Become a Mentor</h4></a>
        </div>
      </header>

      <div className="section schedule">
        <h2>Event Schedule</h2>
        <div className="events">
          { events.map(event => <Event name={event.name} weekday={event.weekday} shortDate={event.shortDate} info={event.info} description={event.description} />) }
        </div>
      </div>

      <div className="section faq">
        <h2>FAQs and Rules</h2>
        <div className="questions">
          { faq.map(question => <Question question={question.question} answer={question.answer} />) }
        </div>
      </div>

      <div className="section copyright">
        <p>© 2022 ICSSC Events and Projects Committees • Website designed by Ryan Mohta</p>
      </div>

    </div>

  );
}

function Event(props) {
  return (
    <div className="Event">
      <div className="header">
        <div className="date">
          <h5>{ props.weekday }</h5>
          <h4>{ props.shortDate }</h4>
        </div>
        <div className="text">
          <h3>{ props.name }</h3>
          <h5 dangerouslySetInnerHTML={{ __html: props.info }} />
        </div>
      </div>
      <p dangerouslySetInnerHTML={{ __html: props.description }} />
    </div>
  )
}

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isFlipped: false };
  }

  handleClick = () => {
    this.setState({ isFlipped: !this.state.isFlipped });

  };

  render() {
    return (
      <ReactCardFlip isFlipped={this.state.isFlipped}>
        <div className="Question" onClick={this.handleClick}>
          <h3>{ this.props.question }</h3>
        </div>

        <div className="Question answered" onClick={this.handleClick}>
          <p dangerouslySetInnerHTML={{ __html: this.props.answer }} />
        </div>
      </ReactCardFlip>
    );
  }
}

export default App;
